import Vue from "vue";
import VueRouter from "vue-router";
import HomeView from "../views/HomeView.vue";
import NotFound from "../views/404.vue";
import Forbidden from "../views/403.vue";
import Xiezuoupload from "../views/Xiezuoxvchuan/Xiezuoupload.vue";
import Xiezuophoto from "../views/Xiezuoxvchuan/Xiezuophoto.vue";
import NProgress from "nprogress";
import "nprogress/nprogress.css";
import store from '@/store'
Vue.use(VueRouter);
const routes = [{
    path: "/",
    name: "login",
    hideInMenu: true,
    component: () =>
        import( /* webpackChunkName: "about" */ "../views/Login/Index.vue"),

},
{
    path: "/register",
    name: "register",
    hideInMenu: true,
    component: () =>
        import( /* webpackChunkName: "about" */ "../views/Login/Register.vue"),

},
{
    path: "/resetpass",
    name: "resetpass",
    hideInMenu: true,
    component: () =>
        import( /* webpackChunkName: "about" */ "../views/Login/Resetpass.vue"),

},
{
    path: "/zuzhao/index",
    name: "zuzhao",
    hideInMenu: false,
    meta: {
        name: '组照'
    },
    component: () =>
        import( /* webpackChunkName: "about" */ "../layouts/Main.vue"),
    children: [{
        path: '/zuzhao/index',
        name: 'index',

        meta: {
            name: '组照首页'
        },
        component: () =>
            import( /* webpackChunkName: "about" */ "../views/Zuzhao/Index.vue"),

    },
    {
        path: '/zuzhao/guidangindex',
        name: 'guidangindex',

        meta: {
            name: '组照归档页'
        },
        component: () =>
            import( /* webpackChunkName: "about" */ "../views/Zuzhao/Guidangindex.vue"),

    },
    {
        path: '/zuzhao/create',
        name: 'create',

        meta: {
            name: '创建组照'
        },
        component: () =>
            import( /* webpackChunkName: "about" */ "../views/Zuzhao/Create.vue"),


    },
    {
        path: '/zuzhao/edit',
        name: 'edit',

        meta: {
            name: '编辑组照'
        },
        component: () =>
            import( /* webpackChunkName: "about" */ "../views/Zuzhao/Edit.vue"),


    },
    {
        path: '/zuzhao/upload',
        name: 'upload',

        meta: {
            name: '续传'
        },
        component: () =>
            import( /* webpackChunkName: "about" */ "../views/Zuzhao/Upload.vue"),


    },
    {
        path: '/zuzhao/photo',
        name: 'photo',
        meta: {
            name: '编辑图片'
        },
        component: () =>
            import( /* webpackChunkName: "about" */ "../views/Zuzhao/Photo.vue"),


    },

    ]

},
{
    path: "/zhuanti/index",
    name: "zhuanti",
    hideInMenu: false,
    meta: {
        name: '专题'
    },
    component: () =>
        import( /* webpackChunkName: "about" */ "../layouts/Main.vue"),
    children: [{
        path: '/zhuanti/index',
        name: 'index',

        meta: {
            name: '专题首页'
        },
        component: () =>
            import( /* webpackChunkName: "about" */ "../views/Zhuanti/Index.vue"),

    },
    {
        path: '/zhuanti/create',
        name: 'create',

        meta: {
            name: '创建专题'
        },
        component: () =>
            import( /* webpackChunkName: "about" */ "../views/Zhuanti/Create.vue"),

    },
    {
        path: '/zhuanti/edit',
        name: 'edit',

        meta: {
            name: '编辑专题'
        },
        component: () =>
            import( /* webpackChunkName: "about" */ "../views/Zhuanti/Edit.vue"),

    },
    {
        path: '/zhuanti/set',
        name: 'set',

        meta: {
            name: '专题增减组照'
        },
        component: () =>
            import( /* webpackChunkName: "about" */ "../views/Zhuanti/Set.vue"),

    },

    ]

},
{
    path: "/gongnengshezhi/index",
    name: "gongnengshezhi",
    hideInMenu: false,
    meta: {
        name: '功能设置'
    },
    component: () =>
        import( /* webpackChunkName: "about" */ "../layouts/Main.vue"),
    children: [{
        path: '/gongnengshezhi/index',
        name: 'index',
        meta: {
            name: '个人信息'
        },
        component: () =>
            import( /* webpackChunkName: "about" */ "../views/Gongnengshezhi/Index.vue"),
    },
    {
        path: '/gongnengshezhi/getcode',
        name: 'getcode',
        meta: {
            name: '迁移组照到百度云盘'
        },
        component: () =>
            import( /* webpackChunkName: "about" */ "../views/Gongnengshezhi/Getcode.vue"),
    },
    {
        path: '/gongnengshezhi/charge',
        name: 'charge',
        meta: {
            name: '续费'
        },
        component: () =>
            import( /* webpackChunkName: "about" */ "../views/Gongnengshezhi/Charge.vue"),
    },
    {
        path: '/gongnengshezhi/order',
        name: 'order',
        meta: {
            name: '消费记录'
        },
        component: () =>
            import( /* webpackChunkName: "about" */ "../views/Gongnengshezhi/Order.vue"),
    },
    {
        path: '/gongnengshezhi/notice',
        name: 'notice',
        meta: {
            name: '提示栏管理'
        },
        component: () =>
            import( /* webpackChunkName: "about" */ "../views/Gongnengshezhi/Notice.vue"),
    },
    {
        path: '/gongnengshezhi/baidushouquan',
        name: 'baidushouquan',
        meta: {
            name: '迁移组照到百度云盘'
        },
        component: () =>
            import( /* webpackChunkName: "about" */ "../views/Gongnengshezhi/Baidushouquan.vue"),
    },
    {
        path: '/gongnengshezhi/yaoqinghaoyou',
        name: 'yaoqinghaoyou',
        meta: {
            name: '邀请好友'
        },
        component: () =>
            import( /* webpackChunkName: "about" */ "../views/Gongnengshezhi/Yaoqinghaoyou.vue"),
    },
    {
        path: '/gongnengshezhi/fankui',
        name: 'fankui',
        meta: {
            name: '反馈'
        },
        component: () =>
            import( /* webpackChunkName: "about" */ "../views/Gongnengshezhi/Fankui.vue"),
    },
    {
        path: '/gongnengshezhi/ftpzuyong',
        name: 'ftpzuyong',
        meta: {
            name: 'FTP租用'
        },
        component: () =>
            import( /* webpackChunkName: "about" */ "../views/Gongnengshezhi/Ftpzuyong.vue"),
    },
    {
        path: '/gongnengshezhi/yonghuguanli',
        name: 'yonghuguanli',
        meta: {
            name: '用户管理'
        },
        component: () =>
            import( /* webpackChunkName: "about" */ "../views/Gongnengshezhi/Yonghuguanli.vue"),
    },
    ]
},
{
    path: "*",
    name: "403",
    hideInMenu: true,
    component: Forbidden
},
{
    path: "*",
    name: "404",
    hideInMenu: true,
    component: NotFound
},
{
    path: "/xiezuoupload",
    name: "协作续传",
    hideInMenu: true,
    component: Xiezuoupload
},
{
    path: "/xiezuophoto",
    name: "协作编辑图片",
    hideInMenu: true,
    component: Xiezuophoto
}
];

const router = new VueRouter({
    mode: "history",
    base: process.env.BASE_URL,
    scrollBehavior() {
        return { x: 0, y: 0 };
    },
    routes,
    store
});

router.beforeEach((to, from, next) => {
    if (to.path !== from.path) {
        NProgress.start();
    }
    // console.log(localStorage.hasOwnProperty('userobj'))
    
    if (!localStorage.hasOwnProperty('userobj')) {
        if (to.path != '/' && to.path != '/register' && to.path != '/resetpass'&& to.path != '/xiezuoupload'&& to.path != '/xiezuophoto') {
            next({
                path: '/'
            })
            
        }else{
            next();
            NProgress.done();
        }
            // next();
            // NProgress.done();
    } else {
        let quanxian = JSON.parse(localStorage.getItem('quanxian'))
        console.log(quanxian)
        if(quanxian != null){
            if ((quanxian.due_time == null && to.path != '/gongnengshezhi/charge')||(quanxian.due_time != null && quanxian.days_remaining == 0 && to.path != '/gongnengshezhi/charge')) {
                next({
                    path: '/gongnengshezhi/charge'
                })
                NProgress.done();
            }else{
                if(to.path=='/'){
                    next({
                        path: '/zuzhao/index'
                    })
                    NProgress.done();
                }else{
                    next();
                    NProgress.done();
                }          
            }
        }else{
            next();
            NProgress.done();
        }
       
      
        // next();
        // NProgress.done();
        // if (localStorage.hasOwnProperty('userobj')) {
        //     if(quanxian.due_time == null && to.path != '/gongnengshezhi/charge'){
        //         next({
        //             path: '/gongnengshezhi/charge'
        //         })
        //         NProgress.done();
        //     }
        //     if(quanxian.due_time != null && to.path=='/'){
        //         next({
        //             path: '/zuzhao/index'
        //         })
        //         NProgress.done();
        //     }           
        // }else{

        // }
        // if (quanxian.due_time == null && to.path != '/gongnengshezhi/charge'&& to.path != '/') {
        //     next({
        //         path: '/gongnengshezhi/charge'
        //     })
        //     NProgress.done();
        // } else if(quanxian.due_time != null && quanxian.days_remaining == 0 && to.path != '/gongnengshezhi/charge'&& to.path != '/') {
        //     next({
        //         path: '/gongnengshezhi/charge'
        //     })
        //     NProgress.done();           
        // }else{
        //     next();
        //     NProgress.done();
        // }
       
    }

    // let token = localStorage.getItem('Authorization');
    // if (token == null && to.path !== '/user/login') {
    //     next({
    //         path: '/user/login'
    //     })
    // }
    // const record = findLast(to.matched, record => record.meta.authority);
    // if (record && !check(record.meta.authority)) {
    //     if (!isLogin() && to.path !== '/user/login') {
    //         next({
    //             path: '/user/login'
    //         })

    //     } else if (to.path !== "/403") {
    //         notification.error({
    //             message: '403',
    //             description: '你没有权限，请联系管理员',
    //         });
    //         next({
    //             path: "/403"
    //         });
    //     }
    //     NProgress.done();
    // }
            // next();
            // NProgress.done();
});
router.afterEach(() => {
    NProgress.done();
})
export default router;